<script setup>
import { useRemainingTime } from '/app/composables/time';
import { date as formatDate } from '@bignerve/ui-utils';
import { computed } from 'vue';

const props = defineProps({
    label: {
        type: String,
        default: 'Challenge',
    },
    closed: {
        type: Boolean,
        default: false
    },
    iconLeft: {
        type: Boolean,
        default: false
    },
    showClosedTime: {
        type: Boolean,
        default: false
    },
    startDate: {
        type: [String, Date, Number, Object],
    },
    endDate: {
        type: [String, Date, Number, Object],
    },
    autoUpdate: {
        type: [ Number, Boolean ],
        required: false
    }
});


const tooltip = computed(() => [
        props.startDate && `Published ${formatDate(props.startDate, 'YYYY-MM-DD @ HH:mm')}`,
        props.endDate && `Closes: ${formatDate(props.endDate, 'YYYY-MM-DD @ HH:mm')}`,
    ].filter(v => v).join('<br>')
);

const { days, hours, minutes, seconds, ended } = useRemainingTime({
    ...props, strict: true,
});
</script>

<template>
    <div v-tooltip="{ html: true, content: tooltip }" class="flex">
        <div v-if="ended" class="flex flex-col items-center justify-center text-sm text-nerve">
            <span class="flex items-center flex-nowrap leading-tight font-bold">
                <span :class="iconLeft ? 'order-2' : 'order-1'">{{ label }} closed</span>
                <img :class="iconLeft ? 'order-1 mr-1' : 'order-2 ml-1'" class="icon" src="/app/assets/icons/stopwatch.svg" alt="">
            </span>
            <small v-if="showClosedTime">
                <i>{{ formatDate(props.endDate, 'YYYY-MM-DD @ HH:mm') }}</i>
            </small>
        </div>
        <span v-else-if="days > 0" class="text-dust-700">
            <b class="mr-1">{{ label }} closes</b>{{ formatDate(props.endDate, 'human') }}
        </span>
        <template v-else>
            <span class="catalyst-card__footer-meta-item">Time remaining:</span>
            <span class="in-day-countdown">
                <span class="in-day-countdown__digit">{{ hours }}</span>
                <span class="in-day-countdown__digit">{{ minutes }}</span>
                <span class="in-day-countdown__digit">{{ seconds }}</span>
            </span>
        </template>
    </div>
</template>
